<template>
  <div>
    <van-cell-group>
      <van-field
        v-model="formData.name"
        label="单位名称"
        input-align="right"
        placeholder="请输入单位名称"
        @click-left-icon="onQuestion('name')"
      />
    </van-cell-group>

    <van-cell-group>
      <van-field
        v-model="formData.desc"
        label="描述"
        type="textarea"
        placeholder="请输入描述"
        @click-left-icon="onQuestion('desc')"
        rows="1"
      />
    </van-cell-group>
    <div class="row">
      <div class="left-small-label">
<!--        <van-icon class="question-icon" name="question-o" @click="onQuestion('logo')"/>-->
        LOGO
      </div>
      <div class="right-img">
        <PicUploader :fileList="formData.pic" :limit="1" @imageListChange="imageListChange"
                     :name="'pic'"></PicUploader>
        <div class="tip-text">显示在列表页,推荐尺寸750x750,推荐格式jpg</div>
      </div>
    </div>
<!--    <div class="row">-->
<!--      <div class="left-small-label">-->
<!--        <van-icon class="question-icon" name="question-o" @click="onQuestion('pics')"/>-->
<!--        背景图-->
<!--      </div>-->
<!--      <div class="right-img">-->
<!--        <PicUploader :fileList="formData.pics" :limit="1" @imageListChange="imageListChange"-->
<!--                     :name="'pics'"></PicUploader>-->
<!--        <div class="tip-text">显示详情页,推荐宽度不小于750像素,长宽比例为1:1的图片,推荐格式jpg</div>-->
<!--      </div>-->

<!--    </div>-->

    <van-cell-group>
      <van-field
        v-model="formData.phone"
        clearable
        input-align="right"
        label="联系电话"
        placeholder="请输入商家联系电话"
        @click-left-icon="onQuestion('phone')"
      />


      <van-field
        v-model="formData.address"
        label="地址"
        input-align="right"
        :error="formValidate&&!formData.address"
        placeholder="请输入地址"
        required
        @click-left-icon="onQuestion('address')"
      />
<!--      <van-cell-group>-->
<!--        <van-cell title="搜索热词配置"/>-->
<!--      </van-cell-group>-->
<!--      <div class="option" v-for="(item, index) in formData.search_keywords">-->
<!--        <van-field v-model="item.name" placeholder="请输入搜索热词（如 海鲜丸子）"/>-->
<!--        <div class="option-delete">-->
<!--          <img src="https://static.dierqudao.com/images/business/icon-delete.png" alt=""-->
<!--               @click="removeSearchKeywords(index)">-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="row-small">-->
<!--        <van-button type="default" @click="addSearchKeywords">新增搜索热词</van-button>-->
<!--      </div>-->
      <van-field
          v-model="formData.order_add_friend_code"
          clearable
          input-align="right"
          label="微信号"
          placeholder="请输入微信号"
          @click-left-icon="onQuestion('phone')"
      />
    </van-cell-group>

<!--    <div class="row  between">-->
<!--      <div class="left-large-label">订单详情强制加好友</div>-->
<!--      <van-switch v-model="checked"-->
<!--                  size="20px"-->
<!--                  inactive-color="#BFBFBF"-->
<!--                  @change="switchChange"-->
<!--      />-->
<!--    </div>-->
<!--    <div class="row  between">-->
<!--      <div class="left-large-label">海报扫码默认关注公众号</div>-->
<!--      <van-switch v-model="followChecked"-->
<!--                  size="20px"-->
<!--                  inactive-color="#BFBFBF"-->
<!--                  @change="followSwitchChange"-->
<!--      />-->
<!--    </div>-->

    <div class="select-check" v-if="formData.open_order_add_friend==1">
      <van-cell-group>
        <van-field
          v-model="formData.order_add_friend_code"
          clearable
          label="微信号"
          placeholder="请输入微信号"
          left-icon="question-o"
          @click-left-icon="onQuestion('order_add_friend_code')"
        />
      </van-cell-group>

      <div class="row">
        <div class="left-small-label">
          <van-icon class="question-icon" name="question-o" @click="onQuestion('order_add_friend_pic')"/>
          二维码
        </div>
        <PicUploader :fileList="formData.order_add_friend_pic" :limit="9" @imageListChange="imageListChange"
                     :name="'order_add_friend_pic'"></PicUploader>

      </div>

      <van-cell-group>
        <van-field
          v-model="formData.order_add_friend_text"
          clearable
          label="话术"
          placeholder="请输入话术"
        />
      </van-cell-group>
    </div>
    <div class="savebtn">
      <van-button type="danger" size="large" v-if="!saveLoading" @click="submit">保存</van-button>
      <van-button type="danger" size="large" v-else>保存中...</van-button>
    </div>
    <div class="line" style="height: 50px"></div>
  </div>
</template>
<style scoped>
  .question-icon {
    font-size: 16px;
  }

  .row {
    padding: 10px 15px;
    display: flex;
  }

  .row-small {
    padding: 0 15px 10px;
    display: flex;
  }

  .option {
    display: flex;
  }

  .option-delete {
    padding-top: 11px;
    padding-right: 15px;
  }

  .option-delete img {
    width: 22px;
  }

  .savebtn {
    position: fixed;
    z-index: 10;
    bottom: 0;
    width: 100%;
  }

  .tip-text {
    margin-top: 3px;
    color: #969799;
    font-size: 12px;
  }

  .between {
    justify-content: space-between;
  }

  .left-small-label {
    min-width: 90px;
  }

  .left-large-label {
    width: 180px;
  }
</style>

<script>
    import Vue from 'vue';
    import {Field, Uploader, Switch, Button, Cell, CellGroup, Toast, ImagePreview} from 'vant';
    import PicUploader from '@/components/picker/PicUploader.vue';

    Vue.use(Field).use(Uploader).use(Switch).use(Button).use(Cell).use(CellGroup).use(Toast).use(ImagePreview);

    export default {
        name: 'SiteSettingBase',
        components: {
            PicUploader
        },
        data: function () {
            return {
                formData: {
                    name: '',
                    desc: '',
                    pic: [],
                    pics: [],
                    phone: '',
                    address: '',
                    open_order_add_friend: 2,
                    order_add_friend_code: '',
                    order_add_friend_pic: [],
                    order_add_friend_text: '',
                    search_keywords: []
                },
                checked: false,
                followChecked: false,
                saveLoading: false,
                formValidate: false,
            }
        },
        filter: {},
        mounted() {
            document.title = '基本设置';
        },
        created() {
            this.getBusinessSetting();
        },
        destroyed() {
        },
        methods: {
            switchChange(val) {
                let that = this;
                that.formData.open_order_add_friend = val ? 1 : 2;
            },

            followSwitchChange(val) {
                let that = this;
                that.formData.open_weixin_follow = val ? 1 : 2;
            },


            // 新增参数
            addSearchKeywords() {
                // console.log(this.formData.search_keywords)
                if (this.formData.search_keywords.length && this.formData.search_keywords[this.formData.search_keywords.length - 1].name == '') {
                    return false;
                }
                this.formData.search_keywords.push({'name': ''});
            },

            // 移除参数
            removeSearchKeywords(index) {
                this.formData.search_keywords.splice(index, 1);
            },

            getBusinessSetting() {
                let that = this;
                that.$api.get('/wyhadminapi/weiyuanhui/getWyhSetting', {}, (res) => {
                    that.formData = res.data;
                    that.checked = res.data.open_order_add_friend == 1 ? true : false;
                    that.followChecked = res.data.open_weixin_follow == 1 ? true : false;
                })
            },

            submit() {
                let that = this;

                that.formValidate = true;
                console.log('that.formData', that.formData);
                that.saveLoading = true;

                that.$api.post('/wyhadminapi/weiyuanhui/wyhSetting', that.formData, (res) => {
                    Toast.success('设置成功');
                    that.saveLoading = false;
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;

                })
            },

            imageListChange(data) {

                console.log('data', data)
                let that = this;
                let name = data.name
                that.formData[name] = data.pic
            },
            onQuestion(type) {
                // ImagePreview({
                //     images: [require('../../../assets/images/question/tip-business-' + type + '.png')],
                //     closeable: true
                // });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// SiteSettingBase.vue?2dbb41da